import { render } from "./RolePermission.vue?vue&type=template&id=1b14a2d4"
import script from "./RolePermission.vue?vue&type=script&lang=js"
export * from "./RolePermission.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__